import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import store from './store/store';
import "./main.scss";
import './components/dashboard/course.css';

ReactDOM.render(
<React.StrictMode>
  <Provider store={store}>
      <BrowserRouter>
        <Routes>
            <Route path="/*" element={<App/>}>
            </Route>
        </Routes>
      </BrowserRouter>
  </Provider></React.StrictMode>,
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
